import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_LINKS } from '@/helpers/links';
import { AML_CASE_STATUSES } from '@/helpers/compliance';
import { useGetAmlNotifications } from '@/query/queries/compliance/useGetAmlNotifications';
import { useDismissAmlNotification } from '@/query/queries/compliance/useDismissAmlNotification';
import { AmlAlert } from './AmlAlert';
import s from './index.module.scss';

const ALERT_TYPES = {
  [AML_CASE_STATUSES.REVIEW]: 'info',
  [AML_CASE_STATUSES.DOCUMENTS_REQUIRED]: 'warning',
  [AML_CASE_STATUSES.COMPLETED]: 'success',
  [AML_CASE_STATUSES.REJECTED]: 'error',
};

const DISMISSIBLE_STATUSES = [AML_CASE_STATUSES.COMPLETED, AML_CASE_STATUSES.REJECTED];

export const AmlNotifications = () => {
  const { t } = useTranslation('dashboard');
  const navigate = useNavigate();
  const { data: notifications } = useGetAmlNotifications();
  const { mutate: dismiss } = useDismissAmlNotification();

  const alerts = (Array.isArray(notifications) ? notifications : []).filter(
    item => ALERT_TYPES[item.status],
  );

  if (!alerts.length) return null;

  return (
    <div className={s.list}>
      {alerts.map(item => (
        <AmlAlert
          key={item.case_id}
          type={ALERT_TYPES[item.status]}
          title={item.title}
          description={item.description}
          actionLabel={
            item.status === AML_CASE_STATUSES.DOCUMENTS_REQUIRED
              ? t('aml_alerts.upload_documents')
              : undefined
          }
          onAction={
            item.status === AML_CASE_STATUSES.DOCUMENTS_REQUIRED
              ? () => navigate(APP_LINKS.complianceForm(item.case_id))
              : undefined
          }
          onClose={
            DISMISSIBLE_STATUSES.includes(item.status) ? () => dismiss(item.case_id) : undefined
          }
        />
      ))}
    </div>
  );
};
